import script from "./footer.vue?vue&type=script&lang=ts&setup=true"
export * from "./footer.vue?vue&type=script&lang=ts&setup=true"

import "./footer.vue?vue&type=style&index=0&id=0f46c661&lang=scss&scoped=true"

import exportComponent from "D:\\fuwumao\\zecai-official-website\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.45_webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f46c661"]])

export default __exports__